export default __webpack_public_path__ + "static/media/approve-image.a8effa4f.png";